import React, { useEffect, useState } from "react";
import Product from "../auth/product.connect";
import { StarIcon } from "@heroicons/react/20/solid";
const reviews = { href: "#", average: 4, totalCount: 117 };

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ReviewsComponent = ({ product_id, onlyStars }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [menu2Visible, setMenu2Visible] = useState(false);
  const [reviews, setReviews] = useState(null);
  const [ totalCount, setTotalCount ] = useState(0);
  const [rating, setRating] = useState(2);
  const [reason, setReason] = useState("");
  const [isPost, setIsPost] = useState(false);
  const [btn, setBtn] = useState("Post");
  const [ loading, setLoading ] = useState(true);
  const [ averageRating, setAverageRating ] = useState(0);

  const getReviews = async () => {
    const response = await new Product().productReviews(product_id);
    const result = response?.data;
    setReviews(result);
    setLoading(false);
    setTotalCount(result?.length);
    const averageRate = reviews && reviews.length ? reviews.reduce((acc, { rate }) => acc + rate, 0) / reviews.length : 0;
    setAverageRating(averageRate);
  };

  const postPorductReview = async (e) => {
    e.preventDefault();
    setBtn("Posting...");
    const encodedURLIS = encodeURIComponent(window.location.href);
    try {
      const result = await new Product().postProductReviews({
        product_id,
        rate: rating,
        reason,
      });
      setBtn("Please wait...");
      console.log(result)
      if (!result) {
        alert("Please try again later.");
        setBtn("try again");
      } else {
        alert("Review Posted.");
        setBtn("Post");
        window.location.reload();
      }
      setBtn("Post")
    } catch (error) {
      const msg =
        new Product().handleTheError(error) ||
        "An Error occured please try again.";
      alert( msg == "Please provide a valid token." ? "Please login to continue." : msg );
      if(msg == "Please provide a valid token."){
        window.location = `/signin?redirect=${encodedURLIS}`;
      }
      setBtn("Post");
    }
  };

  function generateStars(rate) {
    const maxStars = 5;
    const filledStarCount = Math.floor(rate / (maxStars / 2));
    const emptyStarCount = maxStars - filledStarCount;

    const filledStars = Array.from({ length: filledStarCount }, (_, index) => (
      <svg
        key={`star-filled-${index}`}
        className="w-4 h-4 text-yellow-300 mr-1"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 22 20"
      >
        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
      </svg>
    ));

    const emptyStars = Array.from({ length: emptyStarCount }, (_, index) => (
      <svg
        key={`star-empty-${index}`}
        className="w-4 h-4 text-gray-300 dark:text-gray-500 mr-1"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 22 20"
      >
        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
      </svg>
    ));

    return [...filledStars, ...emptyStars];
  }

  useEffect(() => {
    getReviews();
  }, []);

  function formatDate(dateString) {
    const options = { year: "numeric", month: "long" };
    const joinedDate = new Date(dateString);
    const formattedDate = joinedDate.toLocaleDateString("en-US", options);
    return `Joined on ${formattedDate}`;
  }

  return (
   <div>
    { !loading
     &&
       <div className="mb-6">
       {(
         <div className="">
             <div className="lg:col-span-2 lg:border-r lg:border-gray-200 lg:pr-8">
               <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
                 Reviews
               </h1>
             </div>
 
           <div class="flex items-center">
           <div className="flex items-center">
                   <div className="flex items-center">
                     {[0, 1, 2, 3, 4].map((rating) => (
                       <StarIcon
                         key={rating}
                         aria-hidden="true"
                         className={classNames(
                           averageRating > rating
                             ? "text-yellow-300"
                             : "text-gray-200",
                           "h-5 w-5 shrink-0"
                         )}
                       />
                     ))}
                   </div>
                  {onlyStars &&  <a
                     className="ml-3 text-sm font-medium text-indigo-600 hover:text-indigo-500"
                   >
                     {totalCount} review{totalCount <= 1 ? "" : "s"}
                   </a>}
                 </div>
             { !onlyStars && <span 
               onClick={() => !onlyStars && setIsPost(!isPost)}
             className="flex cursor-pointer p-2 m-1 w-16 text-gray-600">
               {!isPost?"POST":"CLOSE"}
             </span>}
           </div>
         </div>
       )}
 
       {(!onlyStars && isPost) && (
         <div className="gird container mt-4 mb-8 m-2 p-2">
           <div class="space-y-4 md:space-y-6" action="#">
             <div>
               <label
                 for="reason"
                 class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
               >
                 Reason
               </label>
               <input
                 type="reason"
                 name="reason"
                 id="reason"
                 value={reason}
                 onChange={(e) => setReason(e.target.value)}
                 class="border border-gray-300 text-gray-900 sm:text-sm rounded-none focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:border-gray-600 dark:text-primary dark:focus:ring-blue-500 dark:focus:border-blue-500"
                 placeholder="Comment"
                 required=""
               />
             </div>
 
             <div>
               <label
                 for="rating"
                 class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
               >
                 rating
               </label>
               <select
                 type="text"
                 name="rating"
                 id="rating"
                 value={rating}
                 onChange={(e) => setRating(e.target.value)}
                 class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-none focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:border-gray-600 dark:placeholder-gray-400 dark:text-primary dark:focus:ring-blue-500 dark:focus:border-blue-500"
                 placeholder="....."
                 required=""
               >
                 <option value={1}>1</option>
                 <option value={2}>2</option>
                 <option value={3}>3</option>
                 <option value={4}>4</option>
                 <option value={5}>5</option>
               </select>
             </div>
 
             <button
               onClick={(e) => postPorductReview(e)}
               class="w-full text-white bg-primary hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-none text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
             >
               {btn}
             </button>
           </div>
         </div>
       )}
 
       {(!onlyStars && reviews) &&
         reviews?.map(
           ({ username, reason, updatedAt, country, rate, image }, i) => (
             <article>
               <div class="flex items-center mb-4 space-x-4">
                 {/* {image ? (
                   <img class="w-10 h-10 rounded-full" src={image} alt="" />
                 ) : (
                   <img
                     class="w-10 h-10 rounded-full"
                     src="data:image/jpeg;base64,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"
                     alt=""
                   />
                 )} */}
                 {/* <div class="space-y-1 font-medium dark:text-white">
                   <p>
                     {username}{" "}
                     <time
                       // datetime="2014-08-16 19:00"
                       class="block mb-4 text-sm text-gray-500 dark:text-gray-400"
                     >
                       {country}, {formatDate(updatedAt)}
                     </time>
                   </p>
                 </div> */}
               </div>
 
               <div class="flex items-center mb-1">
               {[0, 1, 2, 3, 4].map((rating) => (
                       <StarIcon
                         key={rating}
                         aria-hidden="true"
                         className={classNames(
                           rate > rating
                             ? "text-yellow-300"
                             : "text-gray-200",
                           "h-5 w-5 shrink-0"
                         )}
                       />
               ))}
               </div>
 
               <p class="mb-2 text-gray-900 dark:text-gray-400">{reason}</p>
               <p class="mb-8 text-gray-900 dark:text-gray-400"></p>
             </article>
           )
         )}
     </div>
    }
   </div>
  );
};

export default ReviewsComponent;
